import { VcodeOperation } from '@shopee-user/otp-constants';
import { ClientID } from '@shopee-user/authentication-redirect';
import { loginByOTPURL } from '@shopee-user/url';

const REDIRECT_CLIENT_ID = ClientID.None;
const AUTHENTICATION_ENTRY_URL = loginByOTPURL.getUrl();
export { REDIRECT_CLIENT_ID, AUTHENTICATION_ENTRY_URL };

export {
  AUTHENTICATE_CONTACT_US_LINK,
  AUTHENTICATE_HELP_LINK,
  ONE_CREDENTIAL_RECLAIM_PHONE_FAILED_HELP_LINK,
  SIGNUP_HELP_LINK,
  ACCOUNT_SUSPENDED_HELP_LINK,
  RESET_PASSWORD_INFO_LINK,
  USER_ACCOUNT_CONTACT_US_LINK,
  LOGIN_FRAUD_CONTACT_US_LINK,
  CHANGE_PHONE_HELP_LINK,
  TERMS_OF_SERVICE_LINK,
  PRIVACY_POLICY_LINK,
  COOKIE_POLICY_LINK,
  PHONE_OR_EMAIL_LINKED_CONTACT_US_LINK,
  ACCOUNT_DELETE_IOS_LINK,
  ACCOUNT_DELETE_ANDROID_LINK,
  CHANGE_PHONE_NATIVE_VERIFICATION_LINK,
  TOC_ACCOUNT_CONTACT_US_LINK,
  TERMS_OF_SERVICE_WEBVIEW_LINK,
  PRIVACY_POLICY_WEBVIEW_LINK,
  DATA_PROTECTION_POLICY_LINK,
  PLATFORM_PARTNER_RULES_LINK,
} from './customerServicesUrl';

export {
  SHOPEE_PRIVACY_POLICY_LINK,
  SHOPEE_TERMS_OF_SERVICE_LINK,
  SHOPEE_HOMEPAGE_LINK,
  EXTERNAL_HOMEPAGE_LINK,
} from '@shopee-user/shared-customization-logic';

export const OtpOperation = {
  LoginOTP: VcodeOperation.TOB_FOODY_DRIVER_LOGIN_OTP,
  LoginPassword: VcodeOperation.NOT_APPLICABLE,
  MigrateOneCredential: VcodeOperation.NOT_APPLICABLE,
  ForgotPassword: VcodeOperation.TOB_ACCOUNT_SHOPEEFOOD_DRIVER_FORGET_PASSWORD,
  SignupOTP: VcodeOperation.TOB_ACCOUNT_SHOPEEFOOD_DRIVER_OTP_SIGNUP,
  AddPhone: VcodeOperation.NOT_APPLICABLE,
  ChangePhone: VcodeOperation.TOB_ACCOUNT_SHOPEEFOOD_DRIVER_CHANGE_PHONE,
  AddEmail: VcodeOperation.NOT_APPLICABLE,
  ChangeEmail: VcodeOperation.TOB_ACCOUNT_SHOPEEFOOD_DRIVER_CHANGE_EMAIL,
  SwitchToCLinkOneCredential: VcodeOperation.NOT_APPLICABLE,
  OneCredentialDelinkOTP: VcodeOperation.NOT_APPLICABLE,
};
